import { Post } from "../app_services/ApiService";
import { Loading, AlertError, AlertInfo, AlertClose, AlertWarning } from "../app_services/AlertService";

export const get_point_balance_store_by_cust_code = async (form, setData, isLoad) => {
    try {
        if (isLoad) {
            Loading()
        }
        let respon = await Post(`mkmedical-api/customer/reward-customer-line-account/get-point-balance-store-by-cust-code`, form);
        if (respon.status !== 200) {
            AlertError();
            return;
        }
        if (respon.data.status !== '1') {
            AlertWarning(respon.data.message)
            return;
        }
        setData(respon.data.data[0])

        if (isLoad) {
            AlertClose();
        }
        return true
    } catch (error) {
        console.log(error)
        AlertError();
    }
};


export const get_reward_wheel_game_tr = async (form, setData, isLoad) => {
    try {
        if (isLoad) {
            Loading('รอสักครู่', 'กำลังตรวจสอบของรางวัลคงเหลือ..')
        }
        let respon = await Post(`mkmedical-api/reward-wheel-game/get-reward-wheel-item`, form);
        if (respon.status !== 200) {
            AlertError();
            return;
        }
        if (respon.data.status !== '1') {
            AlertWarning(respon.data.message)
            return;
        }
        // console.log(respon.data.data)

        if (!isLoad) {
            respon.data.data.forEach((prize, i) => {
                // console.log(`${prize.option}: ${(prize.probability).toFixed(2)}% (${prize.quantity} ชิ้น)`);
            });
        }
        setData(respon.data.data)

        if (isLoad) {
            AlertClose();
        }

        return true
    } catch (error) {
        console.log(error)
        AlertError();
    }
};


export const handle_wheel_game_spin = async (form) => {
    try {

        let respon = await Post(`mkmedical-api/reward-wheel-game/handle-wheel-game-spin`, form);
        if (respon.status !== 200) {
            AlertError();
            return;
        }
        if (respon.data.status !== '1') {
            AlertWarning(respon.data.message)
            return;
        }


        return respon.data.data
    } catch (error) {
        console.log(error)
        AlertError();
    }
};


export const get_reward_history = async (form, setData, isLoad,) => {
    try {
        if (isLoad) {
            Loading()
        }
        let respon = await Post(`mkmedical-api/reward-wheel-game/get-reward-history`, form);
        if (respon.status !== 200) {
            AlertError();
            return;
        }
        if (respon.data.status !== '1') {
            AlertWarning(respon.data.message)
            return;
        }
        setData(respon.data.data)


        if (isLoad) {
            AlertClose();
        }
        return true
    } catch (error) {
        console.log(error)
        AlertError();
    }
};